import Me from "../img/me.png";
import Fb from "../img/icon-facebook.png";
import Insta from "../img/icon-instagram.png";
import Linkedin from "../img/icon-linkedin.png";
import GitHub from "../img/icon-github.png";

import { useSelector, useDispatch } from 'react-redux';

const SocialMap = [
  {
    img: Fb,
    alt: "logo-facebook",
    link: "https://www.facebook.com/GiraldaDesign/",
  },
  {
    img: Insta,
    alt: "logo-instagram",
    link: "https://www.instagram.com/giralda_design/",
  },
  {
    img: Linkedin,
    alt: "logo-linkedin",
    link: "https://www.linkedin.com/in/lorenzo-giralda-29026b19a/",
  },
  {
    img: GitHub,
    alt: "logo-GitHub",
    link: "https://github.com/LorenzoGiralda",
  }
];

const BoxMe = () => {

  const ValueView = useSelector((state) => state.ToggleLight.value)

  return (
    <div className="d-flex flex-column flex-lg-row align-items-center rounded justify-content-center p-2">
      <div className={`${ValueView ? 'bg-light' : 'bg-secondary'} shadow justify-content-center justify-content-lg-start rounded
      me-0 me-lg-3 mb-3 mb-lg-0 d-flex flex-column flex-lg-row flex-lg-nowrap align-items-center h-100`}>
        <div className="d-flex h-100 align-items-end">
          <img style={{'width': '1300px'}} className="img-fluid" src={Me} alt="Lorenzo Giralda - immagine del profilo"></img>
        </div>
        <section className="w-75 h-100 p-2 mt-3 mt-lg-0 d-flex flex-wrap flex-lg-nowrap flex-row flex-lg-column justify-content-between align-items-center h-100">
        { SocialMap.map( dato =>
          <a
            href={dato.link} target="_blank" rel="noreferrer" 
            className="p-2 my-1 rounded-circle d-flex justify-content-center align-items-center border border-dark"
            style={{ width: "40px", height: "40px" }}
          >
            <img className={dato.img === Fb ? 'w-50' : "img-fluid"} src={dato.img} alt=""></img>
          </a>
        )}
        </section>
      </div>
      <div className={`shadow rounded p-2 d-flex align-items-center h-100 ${ValueView ? 'bg-light' : 'bg-secondary text-white'}`}>
    <p style={{'text-align': "left"}} className={`m-0 p-0`}>
          Piacere di conoscerti! Sono <strong>Lorenzo Giralda </strong>
          un graphic e web designer - developer con oltre 10 anni di esperienza nel settore. 
          Mi occupo sia di pubblicità offline (grafica e stampa di biglietti da visita, depliant
          ecc.) che online (realizzazione siti web, gestione social ecc.). Nel corso
          della mia carriera, ho avuto l’opportunità di ricoprire ruoli significativi,
          tra cui quello di titolare di uno studio grafico a Roma e di designer pubblicitario per diverse aziende (tra cui ICT Labs, un importante agenzia
          di comunicazione di Terni) ed attualmente sono il communication manager della Fondazione Panetti.
          Negli ultimi anni grazie alle competenze acquisite nella progettazione di strategie di marketing sia offline
          che online, ho sviluppato dei pacchetti pubblicitari ad hoc per tutte le
          tipologie di attività ed esigenze, fondamentali per avere una comunicazione a 360° efficace e di successo. 
          Sperando di essere scelto come “vostro” responsabile della comunicazione, auguro buona navigazione!
      </p>
      </div>
    </div>
  );
};

export default BoxMe;
